export default {
  common: {
    language: 'Language',
    logoAlt: 'Zhongze Science & Education',
    cancel: 'Cancel',
  },
  chatService: {
    chatNow: {
      label: 'Chat Now',
    },
    emailGate: {
      title: 'Email required',
      desc: 'Please enter your email to continue the chat.',
      successMessage: 'Email submitted. You can continue chatting.',
    },
  },
  nav: {
    home: 'Home',
    products: 'Products',
    software: 'Software',
    eduServices: 'Education',
    support: ' Support',
    cooperation: 'Cooperation',
    about: 'About',

    // Sub-menus & Mega Menu
    learningPlatform: 'Zhongze Learning Platform',
    cloudPlatform: 'Zhongze Cloud Platform',
    laserSoftware: 'Laser Device Software',
    makerK12: 'Maker Education - K12',
    archVocational: 'Architectural Models - Vocational',
    cultHigherVoc: 'Cultural & Creative Design - Higher Vocational',
    artsUni: 'Arts & Crafts - University',
    afterSales: 'After-sales Service',
    faq: 'FAQ',
    download: 'Download Center',
    companyIntro: 'Company Profile',
    news: 'News',
    contact: 'Contact Us',
    device: 'Devices',
    kits: 'Kits',
    softwareService: 'Software Services',
    accessories: 'Accessories',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Kit System',
    kitsAccessories: 'Kit Accessories',
    courses: 'Courses',
  },
  aboutPage: {
    seoTitle: 'About Us - Zhongze Science & Education',
    banner: {
      title: 'About Us',
    },
    about: {
      title: 'About Us',
      body: 'Founded in 2015, Zhongze Education has built a close partnership with Hong Kong Unicom International. Based on STEAM curricula from Europe and the U.S., we independently developed a maker-education system tailored to children in China. Through social learning and hands-on practice, we help children break boundaries and create extraordinary outcomes. With “STEAM Education + Maker Space” at our core and a mission to “cultivate future creators,” we focus on technological creativity education for children aged 3–16. We operate maker learning spaces and independently develop education products and curricula. Centered on modules such as design software learning, laser engraving, and programming, we have formed a distinctive R&D ecosystem and a closed-loop product offering. Children gain future-ready core competencies through real projects. Our vision is to become an advocate for international innovation education. We provide not only courses and maker environments, but also a brand-new way of learning. We believe every child is a future innovator—thinking like a scientist, building like an engineer, creating like a designer, and learning to make like a maker—so they can discover themselves through exploration and achieve their future through practice.',
    },
    intro: {
      title: 'Why Choose Us?',
      desc: 'We advocate international innovation education by delivering courses and maker environments—plus an entirely new way of learning. We believe every child is a future innovator, discovering themselves through exploration and achieving their future through practice.',
      features: {
        projectLearning:
          'Project-based learning: Through real-world projects, children build the core competencies they need for the future.',
        interactiveExperiments:
          'Interactive experiments: These hands-on activities help children master foundational scientific principles while developing problem-solving skills, creativity, and teamwork.',
      },
    },
    images: {
      aboutAlt: 'About Zhongze Science & Education',
      featureIcon1Alt: 'Project-based Learning Icon',
      featureIcon2Alt: 'Interactive Experiments Icon',
      introAlt: 'Why Choose Us',
    },
  },
  newsPage: {
    banner: {
      title: 'News',
    },
    tabs: [
      { id: 'all', name: 'All' },
      { id: 'company', name: 'Company News' },
      { id: 'exhibition', name: 'Exhibition Updates' },
      { id: 'industry', name: 'Industry Updates' },
    ],
    items: [
      {
        title:
          'Henghao Laser Shines at BETT UK 2025: Empowering Education Innovation with Laser Technology',
      },
      {
        title:
          'The Core of K12 Education Innovation: How CO2 Laser Cutters Advance STEAM Teaching',
      },
      {
        title:
          'Henghao Laser Customers Showcase Light 530 at didacta Italia 2025',
      },
      {
        title:
          'Zhongze Science & Education Launches a New Smart Education Solution',
      },
      {
        title:
          'Future Education Trends: Deep Integration of AI and Maker Education',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'News',
    },
    tabs: [
      { id: 'all', name: 'All' },
      { id: 'company', name: 'Company News' },
      { id: 'exhibition', name: 'Exhibition Updates' },
      { id: 'industry', name: 'Industry Updates' },
    ],
    items: [
      {
        title:
          'Zhongze Technology Launches a Next-Gen Educational Robot Kit, Leading the New STEM Trend',
      },
      {
        title:
          'AI Enters Campus: How Programming Education Enhances Students’ Logical Thinking',
      },
      {
        title:
          'National Youth Robotics Competition 2023 Concludes Successfully; Zhongze-Supported Teams Win Big',
      },
      {
        title:
          'Exploring Future Education: Smart Classroom Solutions in the Era of Digital Transformation',
      },
      {
        title:
          'Zhongze Technology Partners with Universities to Build a Joint AI Laboratory',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Maker Education',
        desc: 'A space for experimentation and exploration that supports holistic development.',
      },
      item2: {
        title: 'Open the Door to Smart Learning',
        desc: 'From laser applications to kit-based courses, meet diverse learning needs end to end.',
      },
      item3: {
        title: 'Kit Courses',
        desc: 'AI ISTEAM education | A must-have to boost innovation-course efficiency',
      },
    },
    resources: {
      title: 'Rich STEM Teaching Resources',
      tabs: {
        laser: {
          name: 'Laser Cutter',
          title: 'Laser Devices',
          desc1: 'Desktop smart laser cutting & engraving machine',
          desc2:
            'High-precision cutting | Smart, easy operation | Efficient processing | Safe and eco-friendly',
        },
        software: {
          name: 'Software',
          title: 'Education Software',
          desc1: 'All-in-one, versatile software',
          desc2: 'Cloud Platform | Learning Platform | Light Maker',
        },
        ai: {
          name: 'AI Teaching Assistant',
          title: 'Smart Teaching Assistance',
          desc1: 'Real-time monitoring & device alerts',
          desc2: 'AI Teaching Assistant | Visual Dashboard',
        },
        kits: {
          name: 'Kits & Courses',
          title: 'Rich Course Kits',
          desc1: 'PBL project-based learning',
          desc2: 'Supporting textbooks | Hands-on practice',
        },
      },
    },
    different: {
      title: 'What Makes Us Different',
      items: {
        solution: {
          title: 'Education AI Solutions',
          desc: 'Improve teaching outcomes and learning experiences',
        },
        course: {
          title: 'Creative Thinking Courses',
          desc: 'Designed for children aged 3–16',
        },
        product: {
          title: 'Innovation Education Products',
          desc: 'One-click laser making',
        },
        space: {
          title: 'Maker Exploration Space',
          desc: 'Combining innovation with practicality',
        },
      },
    },
    creative: {
      title: 'Creativity Drives the Future of Making',
      machineDesc: 'Smart desktop laser cutting & engraving machine',
      lightBlue530Desc: 'Smart blue-light laser cutting & engraving machine',
      markM20Desc: 'High-precision laser marking machine',
      light640Desc: 'Professional desktop laser cutting & engraving machine',
    },
    innovation: {
      title: 'How Do We Foster Innovative Learning?',
      desc: 'Zhongze Science & Education is committed to developing high-quality innovation-education products, including laser cutters. These products help students learn by doing across science, technology, engineering, arts, and mathematics.',
      items: {
        steam: 'STEAM',
        coding: 'Coding',
        light530: 'Use Light 530',
        robotics: 'Robotics Technology',
      },
    },
    bottomBanner: {
      title: 'Bring AI Education to Life',
      subtitle:
        'AI + education digital empowerment, integrating innovative ideas',
      desc: 'Focus on customized laser products and technical services, enabling schools and enterprises to integrate [AI + Education]',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Laser Device Software  Light Maker',
      bannerDesc:
        'Professional laser device software—simple, efficient, and focused on cutting and engraving.',
      bannerImageAlt: 'Light Maker Interface',
      creationTitle: 'Make Creation Easy',
      features: {
        proDesignTool: 'Professional-grade Design Tools',
        highPrecisionParams: 'High-precision Parameter Settings',
        multiDeviceControl: 'Multi-device Management & Control',
        assetLibrary: 'Powerful Asset Library Management',
      },
      intro: {
        imageAlt: 'Feature Showcase',
        items: {
          item1: {
            title: 'A Powerful and Easy-to-use Design System',
            desc: 'A robust creation tool that supports high-quality designs in JPG, DXF, AI, DST, PNG, BMP, TIF, and SVG formats.',
          },
          item2: {
            title: 'Professional',
            desc: 'Professional drawing features for every making need. Handle complex designs and simple cuts with ease.',
          },
        },
      },
      downloadTitle: 'Software Download',
      downloadButton: 'Download & Try',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Zhongze Learning Platform',
      bannerDescLine1:
        'Zhongze Learning Platform is an innovative online learning tool designed to provide students and teachers with a comprehensive education software solution.',
      bannerDescLine2:
        'Whether on mobile devices or computers, users can easily access and use our platform.',
      bannerImageAlt: 'Zhongze Learning Platform Interface',
      exploreTitle: 'Explore Endless Possibilities, Create a Brilliant Future',
      exploreTabs: [
        { name: 'Student Portal' },
        { name: 'Teacher Portal' },
        { name: 'Agent Portal' },
        { name: 'One-click Make' },
        { name: 'AI Image Generation' },
      ],
      tabContentAlt: 'Feature Showcase',
      introTitle: 'Innovative Learning Platform',
      introItems: [
        {
          title: 'A New Efficient Learning Experience',
          desc: 'Zhongze Learning Platform integrates course learning, graphic design, and laser cutting in one place. With a clean, card-based interface and smooth interactions, it connects creative design to physical making seamlessly—efficient and easy to pick up.',
        },
        {
          title: 'Smart and Convenient, Beginner-friendly',
          desc: 'Built-in massive asset libraries and smart parameter presets enable one-click making—beginners can start in seconds. Detailed mobile tutorials make onboarding stress-free, while cloud-based real-time device monitoring keeps teaching safe throughout.',
        },
      ],
      introImageAlt: 'Innovative Learning Platform',
      galleryAlt: 'Platform Showcase',
      downloadTitle: 'Software Download',
      downloadApps: [
        { name: 'Zhongze Learning Platform App' },
        { name: 'Zhongze Design Software (PC)' },
      ],
      downloadButtonText: 'Download & Try',
    },
    cloudPlatform: {
      bannerTitle: 'Zhongze Cloud Platform',
      bannerDesc:
        'A one-stop education management tool that supports assignment distribution and collection, device monitoring, repair requests, and parameter configuration—helping teachers, students, and schools manage efficiently.',
      bannerImageAlt: 'Zhongze Cloud Platform Interface',
      exploreTitle: 'Streamline Teaching Management',
      exploreTabs: [
        { name: 'Make' },
        { name: 'Getting Started' },
        { name: 'Advanced Learning' },
      ],
      tabContentAlt: 'Feature Showcase',
      introTitle: 'Improve Education Efficiency',
      introItems: [
        {
          title: 'Easy Operation',
          desc: 'One-click making: built-in asset libraries and parameter configurations support one-click production and streamline workflows. Device monitoring: monitor device status in real time to keep teaching activities running smoothly.',
        },
        {
          title: 'Unified Management',
          desc: 'Device networking: supports connecting other maker-classroom devices and managing them with one click, improving management efficiency.',
        },
        {
          title: 'Real-time Monitoring',
          desc: 'Device status: stay informed of device operation in real time and request repairs promptly when issues occur. Maintenance: the system reminds you to perform maintenance based on runtime and usage frequency, extending device life and improving cutting quality.',
        },
      ],
      introImageAlt: 'Zhongze Cloud Platform',
      galleryTitle: 'Bring AI Education to Life',
      galleryDesc:
        'AI + education digital empowerment, integrating innovative ideas',
    },
  },
  eduServices: {
    banner: {
      title: 'AI + Education',
      desc: 'Zhongze’s digital-intelligence teaching solutions help cultivate innovative talent. Guided by education development and student needs, we provide full-stage AI education solutions for K–12 schools.',
      imageAlt: 'Education Solution Banner',
    },
    recommended: {
      title: 'Recommended Products',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Build an All-in-one Teaching Space',
      tabs: {
        'teaching-assist': 'Smart Teaching Assistance',
        'process-optimize': 'Teaching Process Optimization',
        'device-manage': 'Device Management',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Smart Teaching Assistance',
          features: [
            '·Real-time monitoring & device supplies',
            '·AI smart learning assistant',
            '·Visual dashboard',
          ],
        },
        'process-optimize': {
          title: 'Teaching Process Optimization',
          features: [
            '·Online assignment distribution & grading',
            '·Remote centralized management of course cloud resources',
          ],
        },
        'device-manage': {
          title: 'Device Management',
          features: [
            '·Real-time monitoring of educational devices',
            '·Remote device repair requests',
          ],
        },
      },
      categories: [
        {
          title: 'Online Assignment Distribution & Grading',
          description:
            'An intelligent assignment management system that improves teaching efficiency',
        },
        {
          title: 'Remote Device Repair Requests',
          description:
            'Convenient remote device maintenance and repair services',
        },
        {
          title: 'Remote Centralized Control, Streamlined Workflows',
          description:
            'A unified remote management platform to optimize teaching processes',
        },
        {
          title: 'Course Cloud Resources',
          description:
            'Rich cloud-based course resources and teaching materials',
        },
        {
          title: 'Real-time Monitoring of Educational Devices',
          description:
            'Monitor device status in real time to ensure smooth teaching',
        },
        {
          title: 'AI Teaching Assistant',
          description: 'An AI-driven smart teaching assistance system',
        },
      ],
      solutionCards: [
        { title: 'Innovation Digital-Intelligence Solution' },
        { title: 'K–12 Smart Classroom Solution' },
        { title: 'Secondary & Higher Vocational Skills Solution' },
        { title: 'University AI Classroom Solution' },
      ],
    },
    solutions: {
      title: 'One-stop Education Solutions',
      items: [
        {
          title: 'Devices',
          description:
            'In the era of AI-empowered education, Henghao laser cutters work with a smart cloud platform and deeply integrate with Zhongze’s laser teaching cloud platform. Teachers can manage devices remotely, distribute tasks, and track student progress. This integration improves teaching efficiency and enables more personalized learning experiences.',
          buttonText: 'View Details →',
        },
        {
          title: 'Software',
          description:
            'Zhongze’s education platform integrates AI to deliver personalized learning, smart tools, interactive experiences, and cloud resources. It supports course and assignment management, device monitoring and alerts, and data analytics. Together with Zhongze Learning Platform (App/PC) and the Light Maker tool, it empowers teaching end-to-end, optimizes resources, and drives education innovation—providing strong support for teachers, students, and institutions.',
          buttonText: 'View Details →',
        },
        {
          title: 'Courses',
          description:
            'Zhongze innovation laser-cutting courses are systematic and modular, designed specifically for young learners to spark interest and potential. Covering technology knowledge, innovative thinking, project practice, and scientific experiments, they help children become future innovation talents and contribute to social development.',
          buttonText: 'View Details →',
        },
      ],
    },
    managementPlatform: {
      title: 'Zhongze Smart Teaching Management Platform',
      desc: 'Provides personalized learning paths, smart teaching tools, interactive learning experiences, and a cloud resource library. Supports course management, student progress tracking, online assignments, real-time monitoring and alerts for teaching equipment, data analytics, and more. By integrating AI, it improves teaching outcomes, optimizes the allocation of education resources, and delivers comprehensive support for students, teachers, schools, and education institutions—jointly driving education development and innovation.',
      items: [
        {
          title: 'Innovation Digital-Intelligence Solution',
          alt: 'Innovation Digital-Intelligence Solution',
        },
        {
          title: 'K–12 Smart Classroom Solution',
          alt: 'K–12 Smart Classroom Solution',
        },
        {
          title: 'Secondary & Higher Vocational Skills Solution',
          alt: 'Secondary & Higher Vocational Skills Solution',
        },
        {
          title: 'University AI Classroom Solution',
          alt: 'University AI Classroom Solution',
        },
      ],
      action: {
        text: 'Get a Dedicated Solution',
        alt: 'Contact Us Icon',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Maker Education — K–12',
    },
    intro: {
      title: 'Laser Cutters in Education and Schools',
      desc: 'Using laser cutters in schools is safe, contactless, and digital from idea to finished product—making kids’ imaginative ideas easy to realize.',
      imageAlt: 'Laser cutter used for architectural model making',
    },
    scenesFeatured: {
      title: 'Transform Learning with Cutting-edge Educational Tools',
      desc: 'Provide students with industry-leading technology to enhance creativity, critical thinking, and technical skills.',
    },
    scenes: {
      items: [
        {
          title: 'A Laser Creation Platform for Every Student',
          desc: 'Put our philosophy into practice by building student engagement and empowering learners to develop creative thinking in class with powerful tools.',
        },
        {
          title: 'Electronics & Programming Kits',
          desc: 'Engage students in hands-on coding, robotics, and AI with interactive kits.',
        },
        {
          title: 'Vocational & Technical Education',
          desc: 'Use a laser-technology platform to build career pathways and upskill for a changing job market—creating more opportunities.',
        },
      ],
    },
    solutions: {
      title: 'Architectural Models Are Widely Used Across Many Fields',
      items: [
        { title: 'K–12 Schools / Districts' },
        { title: 'Training Institutions' },
        { title: 'Research Labs & Specialized Courses' },
        { title: 'Makerspaces' },
        { title: 'Architecture & Design Libraries / Museums' },
        { title: 'Creative Courses' },
      ],
    },
    bannerLeft: {
      title: 'Bring AI Education to Life',
      subtitle:
        'AI + education digital empowerment, integrating innovative ideas',
    },
    products: {
      tabs: [
        {
          title: 'Laser Devices',
          title1: 'Ultimate Making Tool - Laser Cutter',
          description:
            'Light 530 and 640 combine top-tier components, high-quality manufacturing processes, and rigorous inspection to deliver powerful laser machines with high performance, strong stability, and precise cutting and engraving—perfectly matching the making needs of innovation education scenarios.',
        },
        {
          title: 'Software',
          title1: 'Drawing Pro - LightMaker',
          description:
            'Designed to provide students with safety, speed, smart features, and some of the most innovative capabilities on the market. LightMaker is compatible with multiple design tools, including AI, PS, CorelDRAW, AutoCAD, and SolidWorks, and supports importing high-quality files such as JPG, DXF, AI, DST, PNG, BMP, TIF, and SVG.',
        },
        {
          title: 'Courses',
          title1: 'Diverse Teaching - Innovation Education Courses',
          description:
            'We know every child is unique, so our courses are flexible and diverse—designed to spark each student’s interests and potential. Content includes (but is not limited to) fundamental STEM knowledge, innovative thinking training, project practice, and scientific experiments.',
        },
      ],
    },
    learning: {
      title: 'How to Use Zhongze Laser Cutters in the Classroom?',
      teacher: {
        title: 'Teachers',
        lines: [
          'Create teaching aids and textbook accessories',
          'Laser cutters help teachers produce teaching aids and classroom accessories efficiently, enabling more innovative teaching methods.',
        ],
      },
      student: {
        title: 'Students',
        lines: [
          'Develop practical skills',
          'In class, laser cutters support cross-disciplinary learning across design, engineering, and technology—helping students turn imagination into reality.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Architectural model making scene 1' },
        { alt: 'Architectural model making scene 2' },
        { alt: 'Architectural model making scene 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Architectural Models - Vocational',
    },
    intro: {
      title: 'How Can Laser Cutters Be Used for Architectural Model Making?',
      desc: 'Use laser cutting and engraving to produce architectural models and even the smallest parts in toy-industry model making. Quickly and precisely cut textiles, plastics, wood, veneer boards, MDF, PMMA, cardboard, paper, foam, polystyrene, film, acrylic, and more.',
      imageAlt: 'Laser cutter used for architectural model making',
    },
    scenesFeatured: {
      title: 'A Transformative Force for Architectural Model Making',
      desc: 'Help you produce fine-scale miniatures and high-quality architectural models, presenting your creative blueprint with precision.',
    },
    scenes: {
      items: [
        {
          title: 'High Precision',
          desc: 'Laser cutters can cut materials with extremely high precision and minimal error, ensuring every part of an architectural model matches the design drawings perfectly.',
        },
        {
          title: 'Diverse Materials',
          desc: 'Showcase the natural texture of wood, the transparency and gloss of acrylic, and the lightness and formability of paper through laser cutting and engraving—each with its own unique charm.',
        },
        {
          title: 'Strong Capability for Complex Shapes',
          desc: 'Laser cutting easily handles complex geometries and fine details commonly found in architectural models—such as curves and irregular structures—unlocking more creative possibilities.',
        },
      ],
    },
    solutions: {
      title: 'Architectural Models Are Widely Used Across Many Fields',
      items: [
        { title: 'Education & Academic Research' },
        { title: 'Model Making & Toy Industry' },
        { title: 'Decorative Elements & Architectural Features' },
        { title: 'Real Estate & Urban Planning' },
        { title: 'Architectural Decoration & Renovation' },
      ],
    },
    bannerLeft: {
      title: 'Bring AI Education to Life',
      subtitle:
        'AI + education digital empowerment, integrating innovative ideas',
    },
    products: {
      tabs: [
        {
          title: 'Suitable Equipment',
          title1: 'Choose the Right Equipment',
          description:
            'Laser equipment can quickly turn students’ ideas into physical outputs—whether for model making, design, or artistic creation. From simple crafts to complex mechanical designs, laser cutters and engravers complete tasks accurately, helping students learn and grow through practice.',
        },
        {
          title: 'Design It Yourself',
          title1: 'Design It Yourself',
          description:
            'Edit designs intuitively and preview the final result. Cut and reproduce the details of any design on various materials: use text, logos, images, or photos to refine your artwork and quickly decorate architectural models.',
        },
        {
          title: 'Your Market',
          title1: 'Improve Students’ Skills',
          description:
            'A portable laser marker is ideal for labeling and detail engraving on architectural models. Easy to operate and convenient to carry—an essential tool for architecture education.',
        },
      ],
    },
    learning: {
      title: 'Interdisciplinary Course Teaching',
      groups: [
        {
          title: 'Scale Models',
          lines: [
            'Accurate and detailed to meet miniature-creation needs',
            'Present laser engraving/cutting details exquisitely on various materials, reduce tedious steps, enable efficient creation, and minimize manual errors.',
          ],
        },
        {
          title: 'Interior Design',
          lines: [
            'Get design details right in one go: the built-in camera previews position and size—what you see is what you get. Execute cutting/engraving efficiently and reduce material waste.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Architectural model making scene 1' },
        { alt: 'Architectural model making scene 2' },
        { alt: 'Architectural model making scene 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Arts & Crafts - University',
    },
    intro: {
      title: 'How to Process Artworks and Crafts with Laser Equipment',
      desc: 'This equipment provides students a platform to turn ideas into physical creations, inspiring innovative thinking and creativity. Students can design unique models and artworks, such as laser paper-cutting and stamps.',
      imageAlt: 'Laser equipment processing arts and crafts',
    },
    scenesFeatured: {
      title: 'Technical Skill Development',
      desc: 'By operating laser cutting and engraving machines, students gain deeper knowledge of materials science and processing techniques, improving hands-on ability and problem-solving skills.',
    },
    scenes: {
      items: [
        {
          title: 'Inspire Creative Thinking',
          desc: 'Laser cutting and engraving machines help realize students’ creative designs—such as models and artworks—enhancing creativity.',
        },
        {
          title: 'Multi-disciplinary Integration',
          desc: 'Laser cutting and engraving involve knowledge from physics, chemistry, materials science, computer science, and more. In university teaching, it promotes cross-disciplinary integration and develops students’ comprehensive capabilities.',
        },
        {
          title: 'Hands-on Teaching Projects',
          desc: 'Laser cutting and engraving can be applied in practical university projects such as engineering training, art design, and cultural creativity. For example, students can use laser machines to create architectural models, mechanical parts, and sculptures—combining theory with practice.',
        },
      ],
    },
    solutions: {
      title: 'Applications in University Craft Making',
      items: [
        { title: 'Custom Retail Items' },
        { title: 'Personalized Gifts' },
        { title: 'Holiday Marketing' },
        { title: 'Jewelry Accessories' },
        { title: 'Personalized Apparel' },
      ],
    },
    bannerLeft: {
      title: 'Bring AI Education to Life',
      subtitle:
        'AI + education digital empowerment, integrating innovative ideas',
    },
    products: {
      tabs: [
        {
          title: 'Suitable Equipment',
          title1: 'Choose the Right Equipment',
          description:
            'By choosing the right laser cutting and engraving equipment, universities can provide advanced hands-on teaching tools that inspire creativity while improving teaching quality and efficiency.',
        },
        {
          title: 'Design It Yourself',
          title1: 'Design It Yourself',
          description:
            'Edit designs intuitively and preview the final result. Engrave and reproduce details of any design on various materials: use text, logos, images, or photos to refine your artwork. Laser engravers are simple to operate and can decorate your artworks quickly.',
        },
        {
          title: 'Arts & Design',
          title1: 'Arts & Design Major Teaching',
          description:
            'In majors such as art design and industrial design, laser cutting and engraving machines are widely used in course projects and capstone work. Students can quickly turn design ideas into physical prototypes, strengthening product prototyping skills.',
        },
      ],
    },
    learning: {
      title: 'Bring Lasers into Schools',
      groups: [
        {
          title: 'Accurate and Efficient, Save Time and Effort',
          lines: [
            'Zhongze laser cutters support camera preview for precise alignment without wasting material—beginners can get started easily.',
            'Smooth and simple to use: place the material and start creating—what you see is what you get.',
            'Create precisely, make the most of every piece of material, saving time, effort, and materials.',
          ],
        },
        {
          title: 'High-power Performance, Handle Diverse Materials with Ease',
          lines: [
            'Equipped with a high-power CO₂ laser tube for both engraving and cutting.',
            'Easily cut and engrave acrylic, wood, bamboo, and more. Build a friendly workflow for makers so creation becomes simpler and more efficient.',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Arts and crafts making scene 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Cultural & Creative Design — Higher Vocational',
    },
    intro: {
      title: 'Laser Equipment in Cultural & Creative Design',
      desc: 'Cultural and creative design programs in higher vocational colleges are often equipped with advanced laser cutting and engraving equipment, such as laser engravers, to meet students’ hands-on learning needs at different stages.',
      imageAlt: 'Laser equipment in cultural and creative design',
    },
    scenesFeatured: {
      title: 'Unlock Endless Possibilities for Creativity and Quality',
      desc: 'With outstanding performance and precise cutting, it has become an indispensable tool for cultural and creative designers.',
    },
    scenes: {
      items: [
        {
          title: 'High-precision Cutting, Perfectly Present Design Details',
          desc: 'For complex, intricate patterns and unique shapes in cultural and creative design, laser cutters reproduce them accurately—ensuring every detail is precisely reflected in the final product.',
        },
        {
          title: 'Processing Diverse Materials',
          desc: 'Laser equipment can process a wide range of materials—such as wood, acrylic, leather, and metal—providing rich options for cultural and creative product design.',
        },
        {
          title: 'Smart Operation, Simplify the Creative Realization Process',
          desc: 'Students simply import their designs into a computer, and the laser cutter automatically recognizes and cuts with precision. This smart workflow reduces the skill barrier while improving stability and reliability in production.',
        },
      ],
    },
    solutions: {
      title: 'Bring More Great Designs into Everyday Life',
      items: [
        { title: 'Cultural-themed Decorative Paintings' },
        { title: 'Creative Lighting Design' },
        { title: 'Home Decor and Accessories' },
        { title: 'Pen Holders & Stationery Storage Boxes' },
        { title: 'Ethnic-style Accessories' },
        { title: 'Travel Souvenirs' },
      ],
    },
    bannerLeft: {
      title: 'Bring AI Education to Life',
      subtitle:
        'AI + education digital empowerment, integrating innovative ideas',
    },
    learning: {
      title:
        'Production Tools for Cultural & Creative Design in Higher Vocational Colleges',
      groups: [
        {
          title: 'Personalized Customization',
          lines: [
            'Laser cutting and engraving machines make it easy to personalize photos, names, or special patterns—meeting consumer demand for unique and meaningful gifts.',
            'For example, engrave customer-specified patterns or text on wooden ornaments, leather accessories, and acrylic decor items to make them more personal.',
          ],
        },
        {
          title: 'Cultural & Creative Derivative Production',
          lines: [
            'From museum cultural souvenirs to movie and anime derivatives, laser cutting and engraving make complex designs visible and product-ready.',
            'It can turn scenic landmarks, iconic buildings, and cultural IP into real products—for example, cutting an ordinary wooden board into a decorative piece with unique patterns and shapes, or engraving an ordinary sheet of paper into exquisite art.',
          ],
        },
        {
          title: 'DIY Creation',
          lines: [
            'Laser equipment helps makers achieve higher-level DIY creations—from small crafts to unique home decor—quickly realized with laser technology.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Cultural and creative design scene 1' },
        { alt: 'Cultural and creative design scene 2' },
        { alt: 'Cultural and creative design scene 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Education Cooperation',
    },
    advantages: {
      title: 'Our Cooperation Advantages',
      items: [
        {
          title: 'Experienced R&D Team',
          desc: 'Zhongze Science & Education has a professional team of engineers and STEM educators, continuously developing innovative products that meet high education standards and engage students.',
        },
        {
          title: 'AI + Education Digital Empowerment',
          desc: 'Zhongze Smart Education Platform: personalized learning, smart tools, interactive experiences; supports course management, progress tracking, assignment submission, device monitoring and data analytics, and rich cloud resources—making teaching more efficient.',
        },
        {
          title: 'Rich Kits and Curriculum System',
          desc: 'We offer courses from beginner to advanced levels in laser cutting, smart home, smart transportation, and more—meeting the needs of students of different ages.',
        },
      ],
    },
    modes: {
      title: 'Cooperation Models',
      carouselAlts: [
        'Education cooperation scenario',
        'Education cooperation classroom',
        'Education cooperation practice',
      ],
      items: [
        {
          title: 'Curriculum Adoption',
          desc: 'Partner institutions can directly adopt our curriculum system to quickly improve teaching quality.',
        },
        {
          title: 'Kits',
          desc: 'Kits are designed for children aged 3–16. With safe and easy-to-use materials, they spark interest in Science, Technology, Engineering, Arts, and Mathematics (STEAM).',
        },
        {
          title: 'Product Collaboration',
          desc: 'Partner institutions can purchase our education products, such as laser cutters, for teaching and student practice.',
        },
        {
          title: 'Joint R&D',
          desc: 'We welcome partners to participate in the R&D of courses and products to jointly drive education innovation.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'Bring AI Education to Life',
        'AI + education digital empowerment, integrating innovative ideas',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Download Center',
      sectionTitle: 'Software Download',
      downloadButtonText: 'Download Client',
      softwareList: [
        { name: 'Light Maker App' },
        { name: 'Good-laser Light Maker' },
        { name: 'Zhongze Learning Platform App' },
        { name: 'Zhongze Learning Platform' },
      ],
    },
    afterSales: {
      bannerTitle: 'After-sales Service',
      serviceTitle: 'AR Smart Service',
      serviceItems: [
        {
          title: 'Remote Diagnostics',
          desc: 'AR remote guidance: the support team checks device status in real time, diagnoses issues quickly, and provides precise recommendations.',
        },
        {
          title: 'Virtual Maintenance',
          desc: 'AR operation demo: virtually displays repair steps in an intuitive way, helping you master the process easily.',
        },
        {
          title: 'Smart Tutorials',
          desc: 'AR interactive learning: view operating guides directly on the device—efficient and convenient.',
        },
        {
          title: 'Fast Response',
          desc: 'AR instant support: respond quickly, reduce waiting, and resolve issues more efficiently.',
        },
      ],
      videosTitle: 'Tutorial Videos',
      playButtonText: 'Play Video',
      videos: [
        { title: 'Unboxing Demonstration' },
        { title: 'Device Communication Connection Methods' },
        { title: 'Light 530 Tutorial' },
        { title: 'Unboxing & Setup Guide' },
        { title: 'Basic Software Operations' },
        { title: 'Common Troubleshooting' },
      ],
      manualsTitle: 'User Manuals',
      viewPdfButtonText: 'View PDF',
      manuals: [
        { title: 'Light 530 User Manual' },
        { title: 'Light 640 User Manual' },
        { title: 'Blue 530 User Manual' },
        { title: 'M20 Maintenance Guide' },
        { title: 'Laser Cutting Safety Manual' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Three Major Kit Series',
      bannerDesc:
        'The kits support personalized learning for students of different ages and learning needs, while providing teachers with rich teaching resources and tools to help them teach and guide more effectively.',
      sections: {
        educationTitle: 'Education Kits',
        educationDesc: 'Cultivate innovative thinking and creativity',
        creativityTitle: 'Creativity-driven, Make the Future',
        projectsTitle: 'Diverse Educational Projects',
      },
      kitsTabs: [
        {
          name: 'Laser Cutting Starter Kit',
          title: 'Laser Cutting Starter Kit\n(Wood Boards Included)',
          desc: 'A laser-cutting STEAM curriculum designed based on Multiple Intelligences theory, STEAM education principles, and project-based learning. Tailored for different age groups, it develops innovation, critical thinking, problem-solving skills, and communication and teamwork.',
        },
        {
          name: 'Wonderful Science Box',
          title:
            'Wonderful Science Box\n(Wood Boards + Micro-circuit Kit Pack)',
          desc: 'Aligned with the Compulsory Education Science Curriculum Standards (2022 edition), the course develops core competencies across four dimensions: scientific concepts, scientific thinking, inquiry practice, and attitudes and responsibility. Each lesson produces a scientific creation and covers key concepts such as traditional crafts, engineering and technology, and society—guiding students to think like scientists, strengthen inquiry skills, and build scientific thinking.',
        },
        {
          name: 'AI Programming Kit',
          title: 'AI Programming Kit',
          desc: 'Explore future technology starting with the AI programming kit. Smart Farm, Smart Home, Smart Transportation, and Smart Factory kits help students understand agricultural technology, experience modern life, explore transportation efficiency, and uncover smart manufacturing. Hands-on practice sparks innovation and builds problem-solving skills to prepare for an intelligent world.',
        },
      ],
      creativityItems: [
        {
          title: 'Enhance Hands-on Skills',
          desc: 'These kits integrate STEMA (Science, Technology, Engineering, Arts, Mathematics) education. Through hands-on operation and project practice, they improve practical ability and problem-solving skills.',
        },
        {
          title: 'Cultivate Innovative Thinking',
          desc: 'Encourage students to innovate through design and experimentation, building creativity and innovative thinking. Team projects improve communication and collaboration.',
        },
        {
          title: 'Teaching Support for Educators',
          desc: 'Provide teachers with rich resources and tools to better organize lessons and guide students through hands-on projects.',
        },
      ],
      projectItems: [
        { title: 'Science' },
        { title: 'Technology' },
        { title: 'Programming' },
        { title: 'Arts' },
      ],
      bottomBannerText:
        'Through hands-on operation and project practice, the courses enhance practical skills and real-world problem solving. They cultivate innovative thinking and creativity by encouraging design and experimentation. Team projects strengthen communication and collaboration, while exposure to the latest technologies and tools helps students adapt to future social needs.',
    },
    courses: {
      bannerTitle: 'Curriculum System',
      bannerDesc:
        'A systematic STEAM curriculum designed for different age groups, integrating Science, Technology, Engineering, Arts, and Mathematics to cultivate future innovators.',
      bannerAlt: 'Curriculum System',
      bottomBannerAlt: 'Curriculum Showcase',
      sections: {
        kitsTitle: 'Course Kits',
        kitsDesc: 'A perfect combination of supporting hardware and software',
        seriesTitle: 'Premium Course Series',
      },
      courseTabs: [
        {
          name: 'Age 3–6',
          title: 'Science Exploration System — Early Childhood (6 Lessons)',
          desc: 'Explore common everyday phenomena with science teaching aids to understand patterns and principles behind how things work.',
        },
        {
          name: 'Age 6–12',
          title: 'STEAM Maker System — Youth (3 Lessons)',
          desc: 'Unleash creativity, learn to use equipment, and turn ideas into tangible creations through hands-on practice.',
        },
        {
          name: 'Age 8–13',
          title: 'Laser Cutting Curriculum System (3 Lessons)',
          desc: 'Use equipment to cut structural parts, assemble 3D structures, and refine the design. Programming: understand programming logic and fundamentals for decision-making.',
        },
        {
          name: 'Age 6–15',
          title: 'Artificial Intelligence Curriculum System (4 Lessons)',
          desc: 'Use tools to design and build product appearances, then make creations smart through programming to solve real-life problems. Programming: understand logic and principles of programming decisions and learn Arduino programming syntax.',
        },
      ],
      introItems: [
        {
          title: 'Highly Practical and Hands-on',
          desc: 'The courses emphasize practice. Students operate devices such as laser cutters to turn theory into real skills.',
        },
        {
          title: 'Innovation Mindset Development',
          desc: 'Encourage creative design and making to develop innovative thinking and problem-solving ability.',
        },
        {
          title: 'Project-driven Learning',
          desc: 'Students learn and master knowledge in practice by completing specific project tasks.',
        },
        {
          title: 'Explore Cutting-edge Technology',
          desc: 'Engage with frontier technology through projects and apply what you learn in real tasks.',
        },
        {
          title: 'Systematic Instruction',
          desc: 'Progressing from beginner to intermediate levels, the curriculum teaches laser cutting systematically and helps students build a solid knowledge foundation.',
        },
        {
          title: 'Fun and Challenging',
          desc: 'Designed to be both engaging and challenging, motivating students’ interest and curiosity.',
        },
      ],
      courseListRow1: [{ name: 'Smart Farm' }, { name: 'Smart Home' }],
      courseListRow2: [
        { name: 'Smart Transportation' },
        { name: 'Smart Factory' },
      ],
      bottomBannerText:
        'Featuring hands-on practice, innovative thinking, and interdisciplinary integration, the curriculum adopts project-driven learning so students can master cutting-edge technologies through fun and challenge. Combined with systematic teaching, safety education, and personalized learning, it develops hands-on ability, teamwork, and problem-solving skills. It also encourages showcasing outcomes to strengthen students’ sense of achievement.',
    },
    kitsAccessories: {
      bannerTitle: 'Kit Accessories',
      accessories: [
        { name: 'RGB LED Strip' },
        { name: 'DS1307 Clock Module' },
        { name: 'DHT11 Temperature & Humidity Sensor' },
        { name: 'PIR Motion Sensor' },
        { name: 'LED Lighting Module' },
        { name: 'Fan Module' },
        { name: 'Slot-type Optocoupler Switch' },
        { name: 'Button Module' },
        { name: 'Controller Board' },
        { name: 'Expansion Board' },
        { name: 'Raindrop Sensor' },
        { name: 'TT Motor with Adapter Board' },
        { name: 'Infrared Sensor Module' },
        { name: 'Infrared Remote' },
        { name: 'Gas Sensor' },
        { name: '4-digit 7-segment Display Module' },
        { name: 'Matrix Keypad' },
        { name: 'Light Sensor (Photoresistor)' },
        { name: 'Traffic Light Module' },
        { name: 'Buzzer' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'Smart Desktop Laser Cutting & Engraving Machine',
      sections: {
        advantages: 'Our Advantages',
        aiTitle: 'Bring AI Education to Life',
        aiSubtitle:
          'AI + education digital empowerment, integrating innovative ideas',
        carouselTitle: 'Endless Possibilities Carved by Light',
        specsTitle: 'Specifications',
      },
      bannerFeatures: [
        'Fixed-point Photography / Trace Graphics / Safety Protection',
        'Developed for STEAM Education and Makers',
      ],
      softwareSection: {
        title: 'Easy-to-use and Powerful Laser Cutting System',
        items: [
          'Set different process parameters for different materials, such as cutting, deep engraving, shallow engraving, scanning, and more.',
          'Rich design templates and assets to improve design efficiency.',
          'The camera supports fixed-point photography and assisted design, turning creativity into reality.',
        ],
      },
      advantages: [
        {
          tagTitle: 'High-quality, High-precision Laser',
          desc: 'Equipped with an original imported CO₂ laser tube (10640nm), delivering 50W continuous laser power. Maximum cutting thickness up to 15mm (acrylic). Working speed up to 1000mm/s with 0.025mm repeat positioning accuracy. Ensures precision and enables fast, accurate cutting and engraving for exquisite creative works.',
        },
        {
          tagTitle: 'Integrated Triple Exhaust Filtration System',
          desc: 'An all-in-one design combining a filter screen, activated carbon, and UV ozone-layer filtration. Cleaner and more eco-friendly, while being more compact and convenient—no need to purchase an additional filter box or take up extra space.',
        },
        {
          tagTitle: 'Top-priority Safety Protection',
          desc: 'Passed top-level safety tests in SGS laboratories and certified by the FDA as a Class I laser product. Features a unique safety and operating-status indicator light design for clear and intuitive monitoring of machine status.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'Laser Type', value: 'Sealed CO₂ Glass Laser Tube' },
          { label: 'Laser Head Lift Travel', value: '≤25mm' },
          { label: 'Max Material Thickness', value: '≤22mm' },
          { label: 'Focus Mode', value: 'Auto Focus, Manual Focus' },
          { label: 'Connection', value: 'Supports USB, Ethernet, WiFi' },
          { label: 'Supported OS', value: 'Windows, iOS' },
          {
            label: 'Supported Design Software',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
          {
            label: 'Supported File Formats',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, etc.',
          },
          { label: 'Laser Lifetime', value: '≤9000 hours' },
          {
            label: 'Software',
            value: 'LightMaker (Desktop & Mobile), LightBurn (Desktop)',
          },
          {
            label: 'Control Methods',
            value: '5-inch LCD Touchscreen / Mobile App / PC Software',
          },
          { label: 'Noise', value: '≤60db' },
          {
            label: 'Transmission',
            value:
              'High-speed stepper motor + high-precision linear guide rail + synchronous belt',
          },
          {
            label: 'Safety Protection',
            value:
              'Interlock lid-open stop, collision stop, emergency button, safety key, operating status indicator light, high-temperature alarm for water tank',
          },
          { label: 'Power Supply', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Machine Weight', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Cooling Method',
            value: 'Built-in Water Cooling System (Active Water)',
          },
          {
            label: 'Working Voltage',
            value: 'DC 24V air cooling + aluminum coil',
          },
          { label: 'Water Tank Capacity', value: '3.2L' },
          { label: 'Max Lift', value: '5M' },
          {
            label: 'Water Flow',
            value:
              '1000L/H or external dedicated CW3000 laser chiller (optional)',
          },
        ],
        airPumpSpecs: [
          { label: 'Air Volume', value: '50L/min' },
          { label: 'Noise', value: '≤48dB' },
          { label: 'Air Pressure', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Rated Power', value: '62W' },
          { label: 'Airflow', value: '280m³/H' },
          { label: 'Noise', value: '≤50dB' },
          { label: 'Voltage', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: 'Water Cooling System (Built-in) Specs',
          airPumpTitle: 'Air Pump (Built-in) Specs',
          airPumpValueOnly: 'AC 220V/110V 16W',
          exhaustTitle:
            'Exhaust System (External Integrated Unit), Side-bottom Suction',
          filterTitle: 'Filtration System',
          filterValue:
            'Activated carbon filter cotton + silent fan + industrial-grade activated carbon panel',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: 'Smart Blue-light Laser Cutting & Engraving Machine',
      sections: {
        advantages: 'Our Advantages',
        aiTitle: 'Bring AI Education to Life',
        aiSubtitle:
          'AI + education digital empowerment, integrating innovative ideas',
        carouselTitle: 'Endless Possibilities Carved by Light',
        specsTitle: 'Specifications',
      },
      bannerFeatures: [
        'Process Multiple Materials',
        'Create with Confidence—Make Easily Anytime',
      ],
      advantages: [
        {
          tagTitle: 'Compact Footprint',
          desc: 'Stylish, modern, and compact, the blue-light engraver fits in homes, schools, or studios. The clever combination of a metal body and acrylic lid lets you clearly see the processing process.',
        },
        {
          tagTitle: 'Enclosed Processing for Safety',
          desc: 'Fully enclosed. If the lid is opened during operation, it pauses automatically. In emergencies, a single switch can immediately stop the machine—ideal for home and school use.',
        },
        {
          tagTitle: 'Multi-material Processing, Supports Hundreds of Materials',
          desc: 'Customize products in unique shapes and styles. Add accessories to engrave more forms of materials, such as cups and cylindrical objects—perfect for small business needs.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Cooling System',
          airPumpTitle: 'Air Pump',
          airPumpValueOnly: '—',
          exhaustTitle: 'Exhaust System',
          filterTitle: 'Filtration System',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: 'Laser Type', value: 'Blue-light Laser' },
          { key: 'laserPower', label: 'Laser Power', value: '20W / 40W' },
          {
            key: 'maxCutThickness',
            label: 'Max Cutting Thickness',
            value: '≤10mm',
          },
          { key: 'focusMode', label: 'Focus Mode', value: 'Manual Focus' },
          { key: 'connection', label: 'Connection', value: 'USB Connection' },
          {
            key: 'os',
            label: 'Supported OS',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Software',
            value: 'LightBurn (Desktop)',
          },
          {
            key: 'laserLifetime',
            label: 'Laser Lifetime',
            value: '≥10,000 hours',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Max Material Thickness',
            value: '15mm',
          },
          { key: 'noise', label: 'Noise', value: '≤60dB' },
          { key: 'engraveSpeed', label: 'Engraving Speed', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: 'Supported Design Software',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          { key: 'maxSpeed', label: 'Max Working Speed', value: '1000mm/s' },
          {
            key: 'power',
            label: 'Power Supply',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Work Platform Size',
            value: '520 × 315mm',
          },
          { key: 'accuracy', label: 'Positioning Accuracy', value: '±0.01mm' },
          {
            key: 'repeatAccuracy',
            label: 'Repeat Positioning Accuracy',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Power Requirement',
            value: 'AC 220V ±10%，50Hz',
          },
          { key: 'totalPower', label: 'Total Power', value: '300W' },
          {
            key: 'transmission',
            label: 'Transmission',
            value:
              'High-speed stepper motor + high-precision linear guide rail + synchronous belt',
          },
          {
            key: 'safety',
            label: 'Safety Protection',
            value:
              'Interlock lid-open stop, spring-shaft limit, emergency button, safety key',
          },
          { key: 'weight', label: 'Machine Weight', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Machine Size',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'High-precision Laser Marking Machine',
      sections: {
        advantages: 'Our Advantages',
        aiTitle: 'Bring AI Education to Life',
        aiSubtitle:
          'AI + education digital empowerment, integrating innovative ideas',
        carouselTitle: 'Laser Marking, Creative Customization',
        specsTitle: 'Specifications',
      },
      bannerFeatures: [
        'Safety assurance: dual-switch control and laser protection',
        'High-precision, high-speed, and high-stability marking capability',
      ],
      advantages: [
        {
          tagTitle: 'Diverse Application Scenarios',
          desc: 'Suitable for many industries, including jewelry engraving, personalized items, and part identification. Supports custom engraving for jewelry, perfume bottles, small industrial nameplates, and more.',
        },
        {
          tagTitle: 'Innovative Use in Education',
          desc: 'Mark M20 brings industrial-grade precision into education, becoming an “all-around assistant” for innovation education and helping students progress from basic marking skills to complex project development.',
        },
        {
          tagTitle: 'Compact and Modern',
          desc: 'Designed to be compact and modern with a small footprint, low noise, and a large viewing window. Durable and compliant with safety standards—suitable for educational institutions and public retail environments.',
        },
        {
          tagTitle: 'Complete Marking in Seconds',
          desc: 'Even with the smallest fonts, Mark M20 can finish precise marking in seconds. This speed, combined with the streamlined workflow and efficiency of our laser application software LightMaker, significantly boosts productivity.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Laser Type', value: 'Fiber Laser' },
          { key: 'laserPower', label: 'Laser Power', value: '20W / 30W / 50W' },
          {
            key: 'markArea',
            label: 'Marking Area',
            value:
              'Standard 110×110mm (expandable by replacing different field lenses, such as 175×175mm, etc.)',
          },
          { key: 'maxHeight', label: 'Max Working Height', value: '≤130mm' },
          { key: 'connection', label: 'Connection', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Supported OS',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Power Supply',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Safety Protection',
            value:
              'Interlock lid-open stop, spring-shaft limit, emergency button, safety key',
          },
          { key: 'software', label: 'Supported Software', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Transmission',
            value: 'High-precision electric screw lift for the marking head',
          },
          {
            key: 'fileFormat',
            label: 'Supported File Formats',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: 'Focused Spot Diameter', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'Smart Desktop Laser Cutting & Engraving Machine',
      sections: {
        advantages: 'Our Advantages',
        aiTitle: 'Bring AI Education to Life',
        aiSubtitle:
          'AI + education digital empowerment, integrating innovative ideas',
        carouselTitle: 'Creative Cutting Starts Here',
        specsTitle: 'Specifications',
      },
      bannerFeatures: [
        'Fast / Open Rear Door / Efficient Auto Focus',
        'All-in-one Laser Engraving & Cutting Machine',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Work Area',
          desc: 'Excellent cutting and engraving results with multiple models and laser power configurations to meet different application needs.\nLaser type: DC CO₂\nLaser power: 60W–130W\nLight640 (600*400mm)\nLight960 (900*600mm)\nLight1390 (1300*900mm)\nLight1610 (1600*1000mm)',
        },
        {
          tagTitle: 'Efficient Auto Focus + Red-dot Positioning',
          desc: 'Auto focus enables quick and accurate focusing and positioning before cutting and engraving. With a red-dot positioning beam, you can view the working position in real time. This saves time and delivers better cutting and engraving results.',
        },
        {
          tagTitle: 'Open Rear Door Design',
          desc: 'The open rear door supports materials of unlimited length. With 600mm × ∞ boards, your work becomes more convenient and less constrained.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Excellent Cutting and Engraving Results',
            desc: 'With a high-precision cutting platform, processing of materials such as wood and acrylic reaches enterprise-grade standards and efficiency. Enables batch production of laser craft products, boosting productivity and brand performance.',
          },
          {
            tagTitle: 'High-quality Laser Tube and Precision Components',
            desc: 'A diversified product line allows choosing different laser types and processing strengths based on needs, meeting various production requirements and enabling broader applications for wood, glass, acrylic, and more.',
          },
          {
            tagTitle: 'Strict Optical Quality Testing, Guaranteed Quality',
            desc: 'Rigorous production-line testing, precise optical path control, and more than five cutting and engraving tests ensure stable, consistent output from a top-tier CO₂ laser tube. With excellent power stability and a fine laser spot, it achieves uniform engraving and even intricate details.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Excellent Cutting and Engraving Results',
            desc: 'With a high-precision cutting platform, processing of materials such as wood and acrylic reaches enterprise-grade standards and efficiency. Enables batch production of laser craft products, boosting productivity and brand performance.',
          },
          {
            tagTitle: 'High-quality Laser Tube and Precision Components',
            desc: 'A diversified product line allows choosing different laser types and processing strengths based on needs, meeting various production requirements and enabling broader applications for wood, glass, acrylic, and more.',
          },
          {
            tagTitle: 'Strict Optical Quality Testing, Guaranteed Quality',
            desc: 'Rigorous production-line testing, precise optical path control, and more than five cutting and engraving tests ensure stable, consistent output from a top-tier CO₂ laser tube. With excellent power stability and a fine laser spot, it achieves uniform engraving and even intricate details.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Comprehensive & Advanced Safety Features',
            desc: '1. Emergency stop\n2. Alarm light\n3. Waterproof switch\n4. Grounding wire\n5. Built-in thermal detector alarm automatically activates on abnormal activity\n6. Lid lock protection\n7. Durable tempered-glass protective window',
          },
          {
            tagTitle: 'Durable and Outstanding Quality',
            desc: '1. Ideal for single-piece projects or mass production.\n2. Wide selection of work areas, from 600 × 400mm to 1600 × 1000mm.\n3. Unmatched engraving speed.\n4. Designed by industry experts.\n5. Ideal for personalization, education, and industrial applications.',
          },
          {
            tagTitle: 'Optimize Production with Smart Monitoring',
            desc: 'Designed to protect your most expensive components (shafts, laser head, optical elements, lenses) from dust and dirt—ensuring years of trouble-free operation even under heavy use.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'What Can Light 640 Do?',
          items: [
            {
              title: 'Light 640 - Project 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Project 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Project 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Project 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Project 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Project 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Project 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Project 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'What Can Light 960 Do?',
          items: [
            {
              title: 'Light 960 - Project 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Project 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Project 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Project 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Project 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Project 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Project 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Project 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'What Can Light 1390 Do?',
          items: [
            {
              title: 'Light 1390 - Project 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Project 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Project 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Project 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Project 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Project 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Project 7',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Project 8',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'What Can Light 1610 Do?',
          items: [
            {
              title: 'Light 1610 - Project 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Project 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Project 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Project 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Project 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Project 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Project 7',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Project 8',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Cooling System',
          exhaustTitle: 'Exhaust System',
        },
        left: [
          { key: 'model', label: 'Device Model', value: 'Light 640' },
          { key: 'workArea', label: 'Work Area', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'Laser Type',
            value: 'Sealed CO₂ Glass Laser Tube',
          },
          {
            key: 'laserPower',
            label: 'Laser Power',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Z-axis Height',
            value: '135mm (5.3 in)',
          },
          {
            key: 'tableSize',
            label: 'Table Size',
            value: '700 × 530mm (27.6″ × 20.9″)',
          },
          {
            key: 'maxMaterialFrontBack',
            label: 'Max Material Size (Front/Rear Doors Closed)',
            value: '700 × 530 × 170mm (27.6″ × 20.9″ × 6.7″)',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Max Material Size (Rear Door Open)',
            value: '700 × ∞ × 20mm (27.6″ × ∞ × 0.8″)',
          },
          {
            key: 'machineSize',
            label: 'Machine Size (W × L × H)',
            value: '1450 × 950 × 1180mm (57.1″ × 37.4″ × 46.5″)',
          },
          {
            key: 'weight',
            label: 'Machine Weight',
            value: '300kg (660 lb)',
          },
          {
            key: 'maxSpeed',
            label: 'Max Working Speed',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Positioning Accuracy',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Focus Mode',
            value: 'Auto Focus / Manual Focus',
          },
          {
            key: 'resume',
            label: 'Resume After Power Loss',
            value: 'Supported',
          },
          {
            key: 'transmission',
            label: 'Transmission',
            value:
              'High-speed stepper motor + high-precision closed-loop motor',
          },
          {
            key: 'connection',
            label: 'Communication',
            value: 'LAN / USB / WiFi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Software',
            value: 'Good-Laser LightMaker (compatible with LightBurn)',
          },
          {
            key: 'process',
            label: 'Processing',
            value: 'Line Engraving, Cutting, Deep Engraving, Shallow Engraving',
          },
          {
            key: 'fileFormats',
            label: 'Supported File Formats',
            value: 'Bitmap: JPG / PNG / BMP; Vector: LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Frequency',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Phase',
            value: 'Single-phase',
          },
          {
            key: 'current',
            label: 'Full-load Current',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Voltage',
            value: '230V AC',
          },
          {
            key: 'totalPower',
            label: 'Total Power',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Applicable Materials',
            value:
              'Wood, acrylic, leather, fabric, plastic, cardboard, rubber, two-color plates, marble, glass, anodized aluminum, and other non-metal materials',
          },
          {
            key: 'safety',
            label: 'Safety Standards',
            value:
              'Complies with EU CE safety standards, featuring chamber lid-open protection, cooling protection system, temperature-control automatic alarm system, leakage protection system, emergency stop protection system, optical path system, tempered-glass viewing system, operating status indicator lights, and more',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Cooling Method',
            value: 'Water Cooling',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Exhaust Port Diameter',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Sealed CO₂ Glass Laser Tube',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm (5.3 in)',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg (902 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Auto Focus / Manual Focus',
          resume: 'Supported',
          transmission:
            'High-speed stepper motor + high-precision closed-loop motor',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (compatible with LightBurn)',
          process: 'Line Engraving, Cutting, Deep Engraving, Shallow Engraving',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vector: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Single-phase',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Wood, acrylic, leather, fabric, plastic, cardboard, rubber, two-color plates, marble, glass, anodized aluminum, and other non-metal materials',
          safety:
            'Complies with EU CE safety standards, featuring chamber lid-open protection, water-cooling protection system, temperature-control automatic alarm system, leakage protection system, emergency stop protection system, optical path system, tempered-glass viewing system, operating status indicator lights, and more',
          coolingMode: 'Water Cooling',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Sealed CO₂ Glass Laser Tube',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm (5.3 in)',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg (1100 lb)',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Auto Focus / Manual Focus',
          resume: 'Supported',
          transmission:
            'High-speed stepper motor + high-precision closed-loop motor',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (compatible with LightBurn)',
          process: 'Line Engraving, Cutting, Deep Engraving, Shallow Engraving',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vector: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Single-phase',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Wood, acrylic, leather, fabric, plastic, cardboard, rubber, two-color plates, marble, glass, anodized aluminum, and other non-metal materials',
          safety:
            'Complies with EU CE safety standards, featuring chamber lid-open protection, water-cooling protection system, temperature-control automatic alarm system, leakage protection system, emergency stop protection system, optical path system, tempered-glass viewing system, operating status indicator lights, and more',
          coolingMode: 'Water Cooling',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Sealed CO₂ Glass Laser Tube',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm (5.3 in)',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg (1298 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Auto Focus / Manual Focus',
          resume: 'Supported',
          transmission:
            'High-speed stepper motor + high-precision closed-loop motor',
          connection: 'LAN / USB / WiFi',
          software: 'Good-Laser LightMaker (compatible with LightBurn)',
          process: 'Line Engraving, Cutting, Deep Engraving, Shallow Engraving',
          fileFormats: 'Bitmap: JPG / PNG / BMP; Vector: LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Single-phase',
          current: '6A',
          voltage: '230V AC',
          totalPower: '≤ 1.5kW',
          materials:
            'Wood, acrylic, leather, fabric, plastic, cardboard, rubber, two-color plates, marble, glass, anodized aluminum, and other non-metal materials',
          safety:
            'Fully complies with EU CE safety standards, featuring lid-open protection, water-cooling protection, temperature alarms, leakage protection, emergency stop, and a laser closed-loop system',
          coolingMode: 'Water Cooling',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Your email address',
      button: 'Subscribe',
    },
    social: {
      tiktok: 'Douyin',
      weibo: 'WeChat Channels',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu',
    },
    companyDesc:
      'Focused on technological creativity education for children aged 3–16. We operate innovation education spaces and independently develop education products and curricula around modules such as design software learning, laser engraving, and programming.',
    navColumns: [
      {
        title: 'Products',
        items: [
          { label: 'Devices', to: '/product/light530' },
          { label: 'Kits', to: '/product/kits' },
          { label: 'Courses', to: '/product/courses' },
        ],
      },
      {
        title: 'Software',
        items: [
          { label: 'Zhongze Cloud Platform', to: '/software/cloud-platform' },
          {
            label: 'Zhongze Learning Platform',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Education Services',
        items: [
          { label: 'AI Education Solutions', to: '/edu-services' },
          { label: 'Maker Education - K12', to: '/edu-services/maker-k12' },
          {
            label: 'Architectural Models - Vocational',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Cultural & Creative Design - Higher Vocational',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Arts & Crafts - University',
            to: '/edu-services/arts-university',
          },
          { label: 'Innovation Space', to: '/edu-services' },
        ],
      },
      {
        title: 'Service & Support',
        items: [
          { label: 'Download Center', to: '/support/download' },
          { label: 'After-sales Service', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Education Cooperation',
        items: [
          { label: 'Education Cooperation', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'About Us',
        items: [
          { label: 'About Us', to: '/about' },
          { label: 'News', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Sales Hotline: 18379276683',
      email: 'Email: sam@zz-steam.com',
      address:
        'Address: Tower A, Huashengda Building, Bagua 4th Road, Futian, Shenzhen',
    },
    qrDesc: 'Learn More',
  },

  globalContactForm: {
    title: 'Contact Us',
    subtitle: 'Please fill out the form below and we will contact you soon.',
    fields: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      company: 'Company',
      message: 'Message',
    },
    placeholders: {
      name: 'Please enter your name',
      email: 'Please enter your email',
      phone: 'Please enter your phone number',
      company: 'Please enter your company name',
      message: 'Please enter your message',
    },
    submitting: 'Submitting...',
    submit: 'Submit',
    visual: {
      title: 'Looking Forward to Working with You',
      description:
        'We provide professional service and support. If you have any questions, feel free to contact us.',
    },
    contact: {
      phone: 'Phone',
      email: 'Email',
    },
    validation: {
      name: 'Please enter your name',
      email: 'Please enter your email',
      emailFormat: 'Please enter a valid email address',
      phone: 'Please enter your phone number',
      phoneFormat: 'Please enter a valid phone number',
      message: 'Please enter your message',
    },
    success: 'Submitted successfully! We will contact you soon.',
    networkError: 'Submission failed. Please try again later.',
  },
};
